<template>
    <v-container fluid :class="$vuetify.breakpoint.smAndDown ? 'pa-0' : ''">
        <v-row class="d-flex justify-center">
            <v-col :md="printing ? '6' : '9'" cols="12">
                <v-card
                    :rounded="$vuetify.breakpoint.smAndDown ? '0' : '10'"
                    :loading="estadisticaConsecucion.isLoading"
                    elevation="0"
                >
                    <v-card-title primary-title>
                        <v-row>
                            <v-col cols="12" md="8" class="d-flex align-center">
                                <div
                                    v-if="
                                        !$vuetify.breakpoint.smAndDown &&
                                        !printing
                                    "
                                    class="
                                        font-weight-light
                                        primary--text
                                        text-h4
                                        ml-2
                                        text-capitalize
                                    "
                                >
                                    <div class="d-flex align-center">
                                        <v-icon color="primary" left x-large>
                                            mdi-chart-box-plus-outline
                                        </v-icon>
                                        Proyección y Objetivos por Tipo
                                    </div>
                                    <small
                                        class="grey--text d-flex justify-start"
                                    >
                                        {{
                                            currentDate
                                                .toISOString()
                                                .substr(0, 7)
                                        }}</small
                                    >
                                </div>
                                <div
                                    v-else
                                    class="primary--text text-overline ml-2"
                                >
                                    <div>
                                        Proyección y Objetivos por Tipo
                                        <a href="#finObjectivesReportBase">
                                            <v-icon color="primary" right
                                                >mdi-arrow-down-drop-circle</v-icon
                                            >
                                        </a>
                                    </div>

                                    <small
                                        class="grey--text d-flex justify-start"
                                    >
                                        {{
                                            currentDate
                                                .toISOString()
                                                .substr(0, 7)
                                        }}</small
                                    >
                                </div>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="4"
                                :class="
                                    $vuetify.breakpoint.xs
                                        ? 'd-flex justify-center align-center'
                                        : 'd-flex justify-end align-center'
                                "
                            >
                                <div
                                    :class="
                                        !$vuetify.breakpoint.smAndDown &&
                                        !printing
                                            ? 'font-weight-light align-self-center mr-3 grey--text text-h5'
                                            : 'font-weight-light align-self-center mr-3 grey--text text-overline'
                                    "
                                >
                                    {{ printing ? 'Expandir' : 'Comprimir' }}
                                </div>
                                <v-switch
                                    inset
                                    color="primary"
                                    v-model="printing"
                                >
                                </v-switch>
                                <ObjectivesReportDial />
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <!-- <v-divider class="test"></v-divider> -->
                    <v-tabs
                        :show-arrows="$vuetify.breakpoint.smAndDown"
                        fixed-tabs
                        v-model="selectedObjective"
                    >
                        <v-tab
                            v-for="item in tiposObjetivo"
                            :key="item"
                            class="primary--text font-weight-light"
                        >
                            {{ item.replace('_', ' ') }}
                        </v-tab>
                    </v-tabs>
                    <!-- <v-divider class="test"></v-divider> -->
                    <v-data-table
                        id="objectivesReportTable"
                        :headers="currentHeaders()"
                        :items-per-page="tableLength"
                        :dense="printing ? true : false"
                        :footer-props="footerProps"
                        :search="search"
                        :items="
                            selectedTipoComercial || selectedStatusComercial
                                ? tableDictFilterByTipoComercial[
                                      tiposObjetivo[selectedObjective]
                                  ]
                                : tableDict[tiposObjetivo[selectedObjective]]
                        "
                        :item-class="itemRowBackground"
                    >
                        <template v-slot:item.objetivoProy="{ item }">
                            <v-chip
                                class="d-flex grow justify-center flex-wrap"
                                dark
                                :small="printing ? true : false"
                                color="grey darken-1"
                            >
                                {{ getProyeccion(item) }}
                                <v-icon right> mdi-shopping </v-icon>
                            </v-chip>
                        </template>
                        <template v-slot:item.proyeccion="{ item }">
                            <v-chip
                                v-if="!printing"
                                class="d-flex grow justify-center flex-wrap"
                                dark
                                :small="printing ? true : false"
                                color="grey darken-2"
                            >
                                {{ getProyeccionPercent(item) }}
                                <v-icon right> mdi-ticket-percent </v-icon>
                            </v-chip>
                            {{
                                printing
                                    ? getProyeccionPercent(item) + ' %'
                                    : ''
                            }}
                        </template>
                        <template slot="body.append">
                            <v-data-table
                                v-if="$vuetify.breakpoint.xs"
                                :headers="currentHeaders()"
                                :items="
                                    tiposObjetivo.length ? totales[tiposObjetivo[selectedObjective]] : []
                                "
                                disable-sort
                                hide-default-footer
                            >
                                <template v-slot:item.nombre>
                                    <h2>Total</h2>
                                </template>
                                <template v-slot:item.objetivoProy="{ item }">
                                    <v-chip
                                        class="
                                            d-flex
                                            grow
                                            justify-center
                                            flex-wrap
                                        "
                                        dark
                                        :small="printing ? true : false"
                                        color="grey darken-1"
                                    >
                                        {{ getProyeccion(item) }}
                                        <v-icon right> mdi-shopping </v-icon>
                                    </v-chip>
                                </template>
                                <template v-slot:item.proyeccion="{ item }">
                                    <v-chip
                                        v-if="!printing"
                                        class="
                                            d-flex
                                            grow
                                            justify-center
                                            flex-wrap
                                        "
                                        dark
                                        :small="printing ? true : false"
                                        color="grey darken-2"
                                    >
                                        {{ getProyeccionPercent(item) }}
                                        <v-icon right>
                                            mdi-ticket-percent
                                        </v-icon>
                                    </v-chip>
                                    {{
                                        printing
                                            ? getProyeccionPercent(item) + ' %'
                                            : ''
                                    }}
                                </template>
                            </v-data-table>
                            <tr v-else>
                                <th>
                                    <h2>Total</h2>
                                </th>
                                <th>
                                    <h2 class="d-flex justify-center">
                                        {{
                                            tiposObjetivo.length ? 
                                            totales[
                                                tiposObjetivo[selectedObjective]
                                            ][0].consecucion : ''
                                        }}
                                    </h2>
                                </th>
                                <th>
                                    <h2 class="d-flex justify-center">
                                        {{
                                            tiposObjetivo.length ?
                                            totales[
                                                tiposObjetivo[selectedObjective]
                                            ][0].objetivo : ''
                                        }}
                                    </h2>
                                </th>
                                <th v-if="!printing">
                                    <v-chip
                                        class="
                                            d-flex
                                            grow
                                            justify-center
                                            flex-wrap
                                        "
                                        dark
                                        :small="printing ? true : false"
                                        color="grey darken-1"
                                    >
                                        <h2>
                                            {{
                                                tiposObjetivo.length ?
                                                getProyeccion(
                                                    totales[
                                                        tiposObjetivo[
                                                            selectedObjective
                                                        ]
                                                    ][0]
                                                ) : ''
                                            }}
                                            <v-icon right>
                                                mdi-shopping
                                            </v-icon>
                                        </h2>
                                    </v-chip>
                                </th>
                                <th>
                                    <v-chip
                                        v-if="!printing"
                                        class="
                                            d-flex
                                            grow
                                            justify-center
                                            flex-wrap
                                        "
                                        dark
                                        :small="printing ? true : false"
                                        color="grey darken-2"
                                    >
                                        <h2>
                                            {{
                                                tiposObjetivo.length ?
                                                getProyeccionPercent(
                                                    totales[
                                                        tiposObjetivo[
                                                            selectedObjective
                                                        ]
                                                    ][0]
                                                ) : ''
                                            }}
                                            <v-icon right>
                                                mdi-ticket-percent
                                            </v-icon>
                                        </h2>
                                    </v-chip>
                                    <h2 class="d-flex justify-center">
                                        {{
                                            printing && tiposObjetivo.length
                                                ? getProyeccionPercent(
                                                      totales[
                                                          tiposObjetivo[
                                                              selectedObjective
                                                          ]
                                                      ][0]
                                                  ) + ' %'
                                                : ''
                                        }}
                                    </h2>
                                </th>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
            <v-col cols="12" :md="printing ? '2' : '3'">
                <v-row>
                    <v-col cols="12">
                        <v-card
                            elevation="10"
                            :loading="estadisticaConsecucion.isLoading"
                        >
                            <v-card-title primary-title>
                                <v-row>
                                    <v-col cols="12" lg="10">
                                        <div
                                            v-if="$vuetify.breakpoint.mdAndDown"
                                            class="
                                                primary--text
                                                text-overline text-center
                                            "
                                        >
                                            Días laborables
                                        </div>
                                        <div
                                            v-else
                                            class="
                                                font-weight-light
                                                primary--text
                                                text-h5 text-capitalize
                                            "
                                        >
                                            Días laborables
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        lg="2"
                                        :class="
                                            $vuetify.breakpoint.mdAndDown
                                                ? 'd-flex justify-center align-center'
                                                : 'd-flex justify-end align-center'
                                        "
                                    >
                                        <v-icon right size="35" color="primary">
                                            mdi-briefcase
                                        </v-icon>
                                    </v-col>
                                </v-row>
                            </v-card-title>
                            <!-- <v-divider class="test"></v-divider> -->
                            <div class="d-flex justify-center">
                                <div class="d-flex mx-16">
                                    <v-textarea
                                        class="text-h2"
                                        no-resize
                                        v-model="commercialWorkingDays"
                                        clear-icon="mdi-close-circle"
                                        :value="commercialWorkingDays"
                                    ></v-textarea>
                                </div>
                            </div>
                            <div class="px-4">
                                <v-slider
                                    v-model="commercialWorkingDays"
                                    min="0"
                                    :max="31"
                                    always-dirty
                                    step="0.5"
                                >
                                    <template v-slot:prepend>
                                        <v-icon
                                            class="mt-n2 mb-12"
                                            size="40"
                                            @click="
                                                decrementCommercialWorkingDays
                                            "
                                        >
                                            mdi-minus
                                        </v-icon>
                                    </template>

                                    <template v-slot:append>
                                        <v-icon
                                            class="mt-n2 mb-12"
                                            size="40"
                                            @click="
                                                incrementCommercialWorkingDays
                                            "
                                        >
                                            mdi-plus
                                        </v-icon>
                                    </template>
                                </v-slider>
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="12">
                        <v-card
                            elevation="10"
                            :loading="estadisticaConsecucion.isLoading"
                        >
                            <v-card-title primary-title>
                                <v-row>
                                    <v-col cols="12" lg="10">
                                        <div
                                            v-if="$vuetify.breakpoint.mdAndDown"
                                            class="
                                                primary--text
                                                text-overline text-center
                                            "
                                        >
                                            Días laborables hasta hoy
                                        </div>
                                        <div
                                            v-else
                                            class="
                                                font-weight-light
                                                primary--text
                                                text-h5 text-capitalize
                                            "
                                        >
                                            Días laborables hasta hoy
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        lg="2"
                                        :class="
                                            $vuetify.breakpoint.mdAndDown
                                                ? 'd-flex justify-center align-center'
                                                : 'd-flex justify-end align-center'
                                        "
                                    >
                                        <v-icon right size="35" color="primary">
                                            mdi-briefcase
                                        </v-icon>
                                    </v-col>
                                </v-row>
                            </v-card-title>
                            <!-- <v-divider class="test"></v-divider> -->
                            <div class="d-flex justify-center">
                                <div class="d-flex mx-16">
                                    <v-textarea
                                        class="text-h2"
                                        no-resize
                                        v-model="
                                            commercialWorkingDaysUntilToday
                                        "
                                        clear-icon="mdi-close-circle"
                                        :value="commercialWorkingDaysUntilToday"
                                    ></v-textarea>
                                </div>
                            </div>
                            <div class="px-4">
                                <v-slider
                                    v-model="commercialWorkingDaysUntilToday"
                                    min="0"
                                    :max="commercialWorkingDays"
                                    always-dirty
                                    step="0.5"
                                >
                                    <template v-slot:prepend>
                                        <v-icon
                                            class="mt-n2 mb-12"
                                            size="40"
                                            @click="
                                                decrementCommercialWorkingDaysUntilToday
                                            "
                                        >
                                            mdi-minus
                                        </v-icon>
                                    </template>

                                    <template v-slot:append>
                                        <v-icon
                                            class="mt-n2 mb-12"
                                            size="40"
                                            @click="
                                                incrementCommercialWorkingDaysUntilToday
                                            "
                                        >
                                            mdi-plus
                                        </v-icon>
                                    </template>
                                </v-slider>
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="12">
                        <v-card
                            elevation="10"
                            :loading="estadisticaConsecucion.isLoading"
                        >
                            <v-card-title primary-title>
                                <v-row>
                                    <v-col cols="12" lg="10">
                                        <div
                                            v-if="$vuetify.breakpoint.mdAndDown"
                                            class="
                                                primary--text
                                                text-overline text-center
                                            "
                                        >
                                            {{
                                                tiposObjetivo.length && tiposObjetivo[selectedObjective]
                                                    ? tiposObjetivo[
                                                          selectedObjective
                                                      ]
                                                          .toLowerCase()
                                                          .replace('_', ' ')
                                                          .replace(
                                                              /\b\w/g,
                                                              (l) =>
                                                                  l.toUpperCase()
                                                          )
                                                    : ''
                                            }}
                                        </div>
                                        <div
                                            v-else
                                            class="
                                                font-weight-light
                                                primary--text
                                                text-h5 text-capitalize
                                            "
                                        >
                                            {{
                                                tiposObjetivo.length && tiposObjetivo[selectedObjective]
                                                    ? tiposObjetivo[
                                                          selectedObjective
                                                      ]
                                                          .toLowerCase()
                                                          .replace('_', ' ')
                                                          .replace(
                                                              /\b\w/g,
                                                              (l) =>
                                                                  l.toUpperCase()
                                                          )
                                                    : ''
                                            }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        lg="2"
                                        :class="
                                            $vuetify.breakpoint.mdAndDown
                                                ? 'd-flex justify-center align-center'
                                                : 'd-flex justify-end align-center'
                                        "
                                    >
                                        <v-icon right size="35" color="primary">
                                            mdi-list-status
                                        </v-icon>
                                    </v-col>
                                </v-row>
                            </v-card-title>
                            <!-- <v-divider class="test"></v-divider> -->
                            <v-card-text>
                                <v-row>
                                    <v-col md="8">
                                        <div class="font-weight-light text-h5">
                                            Total:
                                        </div>
                                    </v-col>
                                    <v-col md="4">
                                        <div
                                            class="
                                                font-weight-thin
                                                grey--text
                                                text-h5
                                                d-flex
                                                justify-end
                                            "
                                        >
                                            {{
                                                tiposObjetivo.length ?
                                                totales[
                                                    tiposObjetivo[
                                                        selectedObjective
                                                    ]
                                                ][0]['consecucion'] : ''
                                            }}
                                            <!-- {{
                                            getSumSelectedObjectives[
                                                'consecucion'
                                            ]
                                        }} -->
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col md="8">
                                        <div class="font-weight-light text-h5">
                                            Total Objetivo:
                                        </div>
                                    </v-col>
                                    <v-col md="4">
                                        <div
                                            class="
                                                font-weight-thin
                                                grey--text
                                                text-h5
                                                d-flex
                                                justify-end
                                            "
                                        >
                                            {{
                                                tiposObjetivo.length ?
                                                totales[
                                                    tiposObjetivo[
                                                        selectedObjective
                                                    ]
                                                ][0]['objetivo'] : ''
                                            }}
                                            <!-- {{
                                            getSumSelectedObjectives[
                                                'objetivo'
                                            ]
                                        }} -->
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col md="8">
                                        <div class="font-weight-light text-h5">
                                            Proyección:
                                        </div>
                                    </v-col>
                                    <v-col md="4">
                                        <div
                                            class="
                                                font-weight-thin
                                                grey--text
                                                text-h5
                                                d-flex
                                                justify-end
                                            "
                                        >
                                            {{
                                                tiposObjetivo.length ? 
                                                getProyeccionPercent(
                                                    totales[
                                                        tiposObjetivo[
                                                            selectedObjective
                                                        ]
                                                    ][0]
                                                ) : ''
                                            }}
                                            %
                                            <!-- {{
                                            getSumSelectedObjectives[
                                                'proyeccion'
                                            ]
                                        }} -->
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <div id="finObjectivesReportBase"></div>
        <Legend :items="legend" />
        <DateFilterDialog @dateEvent="onClickChild($event)" />
        <ComercialFilterDialog />
    </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { getWorkingDays } from '@/util/libUtil.js';
import ObjectivesReportDial from './ObjectivesReportDial';
import DateFilterDialog from '@/components/GerenciaTeletrabajo/ReportTable/DateFilterDialog.vue';
import LoadingSkeleton from '@/components/ComercialTeletrabajo/DetailedView/LoadingSkeleton.vue';
import ComercialFilterDialog from './ComercialFilterDialog';
import Legend from '@/components/GerenciaTeletrabajo/ComercialesTable/Legend.vue';

export default {
    name: 'objectivesReportBase',
    components: {
        ObjectivesReportDial,
        DateFilterDialog,
        Legend,
        LoadingSkeleton,
        ComercialFilterDialog,
    },
    data: () => ({
        legend: [
            {
                title: 'Objetivo (Nombre)',
                icon: 'mdi-target',
                text: 'Total de objetivos realizados por el comercial',
            },
            {
                title: 'Objetivo',
                icon: 'mdi-bullseye-arrow',
                text: 'Total de objetivos a realizar por el comercial',
            },
            {
                title: 'Items proyección',
                icon: 'mdi-box-shadow',
                text: 'Total de objetivos que debería tener el comercial a día de hoy, según dias laborables',
            },
            {
                title: 'Proyección porcentaje',
                icon: 'mdi-percent-outline',
                text: 'Igual que items proyección pero en porcentaje',
            },
        ],
        show: false,
        loadingTable: true,
        printing: false,
        tableLength: 0,
        commercialWorkingDays: 0,
        commercialWorkingDaysUntilToday: 0,
        selectedObjective: 0,
        tiposObjetivo: [],
        tableDict: {},
        totales: {},
        tableDictFilterByTipoComercial: {},
        footerProps: {
            disableItemsPerPage: true,
            itemsPerPageOptions: [-1],
        },
    }),
    methods: {
        onClickChild(dateChild) {
            this.date = dateChild;
            this.$store.dispatch('objectivesReport/fetchConsecucion');
        },
        openFilterDialog() {
            this.$store.commit(
                'objectivesReport/isOpenProjectionDateFilter',
                true
            );
        },
        easter(Y) {
            var C = Math.floor(Y / 100);
            var N = Y - 19 * Math.floor(Y / 19);
            var K = Math.floor((C - 17) / 25);
            var I =
                C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15;
            I = I - 30 * Math.floor(I / 30);
            I =
                I -
                Math.floor(I / 28) *
                    (1 -
                        Math.floor(I / 28) *
                            Math.floor(29 / (I + 1)) *
                            Math.floor((21 - N) / 11));
            var J = Y + Math.floor(Y / 4) + I + 2 - C + Math.floor(C / 4);
            J = J - 7 * Math.floor(J / 7);
            var L = I - J;
            var M = 3 + Math.floor((L + 40) / 44);
            var D = L + 28 - 31 * Math.floor(M / 4);

            return new Date(`${Y}-${this.padout(M)}-${this.padout(D)}`);
        },
        padout(number) {
            return number < 10 ? '0' + number : number;
        },
        totalesResumen(tableDict) {
            if (Object.keys(tableDict).length != 0) {
                const allowed = ['consecucion', 'objetivo', 'proyeccion'];

                let resumenTotales = {};

                Object.keys(tableDict).forEach((key) => {
                    resumenTotales[key] = [];
                    let dictResumen = {
                        nombre: '',
                        consecucion: 0,
                        objetivo: 0,
                        proyeccion: 0,
                    };
                    tableDict[key].forEach((element) => {
                        allowed.forEach((prop) => {
                            if (prop === 'proyeccion') {
                                dictResumen[prop] += parseFloat(element[prop]);
                            } else {
                                dictResumen[prop] += element[prop];
                            }
                        });
                    });
                    // dictResumen['proyeccion'] /= tableDict[key].length;
                    resumenTotales[key].push(dictResumen);
                });

                return resumenTotales;
            } else {
                return [];
            }
        },
        getArrayWithMaxLen(arr1, arr2) {
            let keyMax = null;
            let keyMin = null;
            keyMax = 'FIJOS_PARTICULAR';
            keyMin = 'FIJOS_PRO';

            if (arr2.length > arr1.length) {
                keyMax = 'FIJOS_PRO';
                keyMin = 'FIJOS_PARTICULAR';
            }

            return { keyMax, keyMin };
        },
        currentHeaders() {
            let headers = [
                {
                    text: 'Comercial',
                    value: 'nombre',
                    align: 'start',
                    show: true,
                },
                {
                    text: this.tiposObjetivo.length
                        ? this.tiposObjetivo[this.selectedObjective].replace(
                              '_',
                              ' '
                          )
                        : '',
                    value: 'consecucion',
                    align: 'center',
                    show: true,
                },
                {
                    text: 'Objetivo',
                    value: 'objetivo',
                    align: 'center',
                    show: true,
                },
                {
                    text: 'Proyección %',
                    value: 'proyeccion',
                    width: '200',
                    align: 'center',
                    show: true,
                },
            ];

            if (!this.printing)
                headers.splice(3, 0, {
                    text: 'Items Proyección',
                    value: 'objetivoProy',
                    align: 'center',
                    width: '200',
                    show: true,
                });

            return headers;
        },
        printThis() {
            let obj = {
                elementId: 'table',
                downloadName: 'proyeccion',
            };

            this.$store.dispatch('util/printThis', obj);
        },
        itemRowBackground: function (item) {
            let color = '';
            let percent = this.getProyeccionPercent(item);

            if (percent == 0) {
                color = 'azul';
            } else if (percent < 80) {
                color = 'rojo';
            } else if (percent < 100) {
                color = 'amarillo';
            } else {
                color = 'verde';
            }

            return color;
        },
        decrementCommercialWorkingDays() {
            this.commercialWorkingDays = this.commercialWorkingDays - 0.5;
        },
        incrementCommercialWorkingDays() {
            this.commercialWorkingDays = this.commercialWorkingDays + 0.5;
        },
        decrementCommercialWorkingDaysUntilToday() {
            this.commercialWorkingDaysUntilToday =
                this.commercialWorkingDaysUntilToday - 0.5;
        },
        incrementCommercialWorkingDaysUntilToday() {
            this.commercialWorkingDaysUntilToday =
                this.commercialWorkingDaysUntilToday + 0.5;
        },
        getProyeccion(item) {
            return (
                (item.consecucion / this.commercialWorkingDaysUntilToday) *
                this.commercialWorkingDays
            ).toFixed(2);
        },
        getProyeccionPercent(item) {
            return item.objetivo != 0
                ? ((100 * this.getProyeccion(item)) / item.objetivo).toFixed(2)
                : 0;
        },
    },
    computed: {
        date: {
            get() {
                return this.$store.state.objectivesReport.date;
            },
            set(value) {
                this.$store.commit('objectivesReport/date', value);
            },
        },
        currentDate: {
            get() {
                let date = this.$store.state.objectivesReport.date;
                return new Date(date);
            },
        },
        getSumSelectedObjectives() {
            let consecucion = 0;
            let objetivo = 0;
            let proyeccion = 0;

            if (Object.keys(this.tableDict).length != 0)
                this.tableDict[
                    this.tiposObjetivo[this.selectedObjective]
                ].forEach((obj) => {
                    consecucion += obj['consecucion'];
                    objetivo += obj['objetivo'];
                    proyeccion += parseFloat(obj['proyeccion']);
                });

            return {
                consecucion: consecucion,
                objetivo: objetivo,
                proyeccion: `${(
                    (100 * this.getProyeccion({ consecucion: consecucion })) /
                    objetivo
                ).toFixed(2)} %`,
            };
        },
        ...mapState('objectivesReport', {
            selectedTipoComercial: (state) => state.selectedTipoComercial,
            selectedStatusComercial: (state) => state.selectedStatusComercial,
            estadisticaConsecucion: (state) => state.estadisticaConsecucion,
            isOpenFilterDialog: (state) => state.isOpenFilterDialog,
        }),
        ...mapState('areaPersonal/calculadora', {
            dateActualInmutable: (state) => state.dateActualInmutable,
        }),
        ...mapGetters('objectivesReport', {
            currentNameMonthYear: 'currentNameMonthYear',
        }),
        ...mapState('util', {
            search: (state) => state.navBarSearchField,
        }),
    },
    watch: {
        estadisticaConsecucion: {
            immediate: true,
            handler() {
                if (this.estadisticaConsecucion?.consecucion?.length != 0) {
                    let dict = {};
                    this.tableDict = {};
                    this.tableLength = 0;

                    this.commercialWorkingDays = getWorkingDays(
                        this.currentDate
                    );

                    if (this.currentDate < this.dateActualInmutable) {
                        this.commercialWorkingDaysUntilToday = getWorkingDays(
                            this.currentDate
                        );
                    } else {
                        this.commercialWorkingDaysUntilToday = getWorkingDays(
                            this.currentDate,
                            true
                        );
                    }

                    this.estadisticaConsecucion?.consecucion?.forEach(
                        (element) => {
                            if (!(element.familia in dict)) {
                                dict[element.familia] = [];
                            }

                            let obj = {};
                            obj['nombre'] = element.nombre;
                            obj['consecucion'] = element.consecucion;
                            obj['objetivo'] = element.objetivo;
                            obj['proyeccion'] =
                                this.getProyeccionPercent(element);
                            obj['tipo_comercial'] = element.tipo_comercial;
                            obj['estado'] = element.estado;
                            this.tableLength++;
                            dict[element.familia].push(obj);

                            if (
                                !this.tiposObjetivo.some(
                                    (obj) => element.familia == obj
                                )
                            )
                                this.tiposObjetivo.push(element.familia);
                        }
                    );

                    this.tableDict = dict;
                    this.totales = this.totalesResumen(this.tableDict);

                    // Check if object is empty
                    if (Object.keys(this.tableDict).length != 0) {
                        // let { keyMax, keyMin } = this.getArrayWithMaxLen(
                        //     this.tableDict['FIJOS_PARTICULAR'],
                        //     this.tableDict['FIJOS_PRO']
                        // );

                        // // Create new array object FIJOS, sum of keyMax and keyMin
                        // let newArray = [];
                        // this.tableDict[keyMax].forEach((element) => {
                        //     let entrada = this.tableDict[keyMin].find(
                        //         (el) => el.nombre == element.nombre
                        //     );

                        //     let obj = {};
                        //     obj['nombre'] = element['nombre'];
                        //     obj['consecucion'] =
                        //         element['consecucion'] + entrada
                        //             ? entrada['consecucion']
                        //             : 0;
                        //     obj['objetivo'] =
                        //         element['objetivo'] + entrada
                        //             ? entrada['objetivo']
                        //             : 0;
                        //     obj['tipo_comercial'] = element.tipo_comercial;
                        //     this.tableLength++;
                        //     newArray.push(obj);
                        // });

                        // this.tableDict['FIJOS'] = newArray;
                        // console.log('FIJO SOLO');
                        // console.log(this.tableDict['FIJOS']);

                        try {
                            this.footerProps.itemsPerPageOptions = [
                                this.tableDict[
                                    this.tiposObjetivo[this.selectedObjective]
                                ].length + 1,
                            ];
                        } catch {}
                    }
                    this.loadingTable = false;
                }
            },
        },
        selectedObjective() {
            this.footerProps.itemsPerPageOptions = [
                this.tableDict[this.tiposObjetivo[this.selectedObjective]]
                    .length + 1,
            ];
        },
        isOpenFilterDialog: {
            immediate: true,
            handler(newValue, oldValue) {
                if (
                    oldValue &&
                    !newValue &&
                    (this.selectedTipoComercial || this.selectedStatusComercial)
                ) {
                    // Filter tableDict by selectedTipoComercial
                    Object.keys(this.tableDict).forEach((key) => {
                        this.tableDictFilterByTipoComercial[key] =
                            this.tableDict[key].filter((item) => {
                                let condition = null;
                                if (this.selectedTipoComercial) {
                                    condition =
                                        item.tipo_comercial ==
                                        this.selectedTipoComercial;
                                }
                                if (this.selectedStatusComercial) {
                                    if (condition != null)
                                        condition &&=
                                            item.estado ==
                                            this.selectedStatusComercial;
                                    else
                                        condition =
                                            item.estado ==
                                            this.selectedStatusComercial;
                                }

                                return condition ? true : false;
                            });
                    });
                }
                if (
                    this.selectedTipoComercial == null &&
                    this.selectedStatusComercial == null
                ) {
                    this.totales = this.totalesResumen(this.tableDict);
                } else {
                    this.totales = this.totalesResumen(
                        this.tableDictFilterByTipoComercial
                    );
                }
            },
        },
    },
    mounted() {
        if (
            this.$store.state.objectivesReport.estadisticaConsecucion
                .consecucion == 0
        ) {
            this.$store.dispatch('objectivesReport/fetchConsecucion');
            // this.$store.dispatch('objectivesReport/fetchHolidayEventsinMonth')
        }
    },
};
</script>

<style>
.verde {
    background-color: rgb(206, 255, 206);
}

.rojo {
    background-color: rgb(255, 191, 191);
}

.naranja {
    background-color: rgb(255, 221, 159);
}

.amarillo {
    background-color: rgb(255, 253, 161);
}

.azul {
    background-color: #cad3eb;
}

textarea {
    padding-top: 40px !important;
    padding-bottom: 0px !important;
    height: 115px;
    text-align: center;
}
#fullHeigth {
    height: 100vh;
    width: 0;
    position: absolute;
}
</style>